import { render, staticRenderFns } from "./xs.vue?vue&type=template&id=6888ef3c&"
import script from "./xs.vue?vue&type=script&lang=js&"
export * from "./xs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports